export const MAX_IMAGE_UPLOADS = 20

export const REPORT_REASON_MAP: {
  [k: string]: {
    label: string
    reportReasonText: string
  }
} = {
  report_scam: {
    label: 'morePopover.report.scam',
    reportReasonText: 'morePopover.report.scam',
  },
  report_sex: {
    label: 'morePopover.report.sex',
    reportReasonText: 'morePopover.report.sex',
  },
  report_offensive: {
    label: 'morePopover.report.offensive',
    reportReasonText: 'morePopover.report.offensive',
  },
  report_violence: {
    label: 'morePopover.report.violence',
    reportReasonText: 'morePopover.report.violence',
  },
  report_prohibited: {
    label: 'morePopover.report.prohibited',
    reportReasonText: 'morePopover.report.prohibited',
  },
  report_spam: {
    label: 'morePopover.report.spam',
    reportReasonText: 'morePopover.report.spam',
  },
  report_falseNews: {
    label: 'morePopover.report.falseNews',
    reportReasonText: 'morePopover.report.falseNews',
  },
  report_other: {
    label: 'morePopover.report.other',
    reportReasonText: 'morePopover.report.other',
  },
}

export const TRACKING_CATEGORY = 'Together'
